import Chart from 'chart.js'

const __show__chart = (ctx, chart_type, used_stacked, data, show_bar_labels, unit) => {
  let font_size_canvas = 20;
  let padding_axis = 20;

  if (($(window).width() <= 991) && ($(window).width() > 767)) {
    font_size_canvas = 14;
    padding_axis = 14;
  } else if (($(window).width() <= 767)) {
    font_size_canvas = 12;
    padding_axis = 8;
  } else if (($(window).width() <= 575)) {
    font_size_canvas = 9;
    padding_axis = 4;
  }

  new Chart(ctx, {
    type: chart_type,
    data: data,
    options: {
      responsive: true,
      legend: false,
      scales: {
        yAxes: [{
          ticks: {
            userCallback: function (label) {
              // when the floored value is the same as the value we have a whole number
              if (chart_type === 'pie' || chart_type === 'doughnut') {
                return '';
              } else {
                return parseFloat(label).toFixed(2);
              }
            },
            beginAtZero: true,
            fontColor: '#152b41',
            fontFamily: 'OpenSansRegular',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: font_size_canvas,
            padding: padding_axis,
          },
          stacked: used_stacked
        }],
        xAxes: [{
          ticks: {
            fontColor: '#152b41',
            fontFamily: 'OpenSansRegular',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: font_size_canvas,
            padding: padding_axis,
            userCallback: function (label) {
              if (chart_type === 'pie' || chart_type === 'doughnut') {
                return '';
              } else {
                return label;
              }
            }
          },
          stacked: used_stacked
        }],
      },
      title: {
        display: false,
        text: 'Chart'
      },
      plugins: {
        legend: false,
        tooltip: true,
        labels: false,
      },
      tooltips: {
        enabled: true,
        mode: 'single',
        backgroundColor: 'rgba(0,0,0, .7)',
        bodyFontStyle: 'normal',
        bodyFontColor: '#ffffff',
        bodyFontFamily: 'OpenSansRegular',
        bodyFontSize: font_size_canvas,
        titleFontStyle: 'normal',
        titleFontColor: '#ffffff',
        titleFontFamily: 'OpenSansRegular',
        titleFontSize: font_size_canvas,
        xPadding: font_size_canvas / 2,
        yPadding: font_size_canvas,
        callbacks:
          {
            label: function (tooltipItems, data) {
              if (chart_type === 'pie' || chart_type === 'doughnut') {
                let index = tooltipItems.index;
                return ' ' + data.labels[index] + ' : ' + data.datasets[0]['data'][index] + unit;
              } else {
                let index = tooltipItems.datasetIndex;
                return ' ' + data.datasets[index].label + ' : ' + tooltipItems.yLabel + unit;
              }
            }
          }
      },
      animation: {
        duration: 1500,
        easing: 'easeOutQuart'
      }
    }
  });
}

const __init_chart = (el) => {
  const chart_type = el.dataset.chartType;
  const unit = el.dataset.chartUnit;
  const used_stacked = el.dataset.chartStacked === 'true';
  const show_bar_labels = el.dataset.showBarLabels === 'true';
  const canvas = el.querySelector('canvas')
  const ctx = canvas.getContext('2d');
  const data = JSON.parse(el.dataset.chartData.replace('\\"', '"'))

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return
      }

      observer.unobserve(el)

      __show__chart(ctx, chart_type, used_stacked, data, show_bar_labels, unit)
    })
  }, {
    rootMargin: '0px',
    threshold: 1.0
  })
  observer.observe(el)
}

export const __init_charts = () => {
  const charts = document.querySelectorAll('.stmnt-widget--chart_inner_data_graph')
  charts.forEach(__init_chart)
}
